import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=0b58ffea&scoped=true"
import script from "./subMenu.vue?vue&type=script&lang=js"
export * from "./subMenu.vue?vue&type=script&lang=js"
import style0 from "./subMenu.vue?vue&type=style&index=0&id=0b58ffea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58ffea",
  null
  
)

export default component.exports